const translations = {
	tabs: {
		users: "Conseillers",
		offices: "Cabinets",
	},
	page_title: "Partenaires",
	title: "Partenaires",
	dopdown_button: "Créer un partenaire",
	table: {
		columns: {
			name: "Nom",
			first_name: "Prénom",
			cabinet: "Cabinet",
			id: "Identifiant",
			raison_social: "Cabinets",
			reseau: "Réseau",
			creation_date: "Date de création",
			number_of_subscriptions: "Nombre de souscriptions",
			last_login_at: "Date de dernière connexion",
		},
	},
	pages: {
		offices: {
			tabs: {
				offices: "Données cabinet",
				users: "Conseillers",
			},
		},
		offices_details: {
			buttons: {
				edit: "Modifier les informations",
				save: "Sauvegarder",
			},
			identite_juridique: {
				title: "Identité juridique",
				company_name: "Raison sociale*",
				forme_juridique: "Forme juridique*",
				siret: "Numéro d'identification de l'entreprise (SIRET, RIDET, T.A.H.I.T.I.)*",
				rcs: "RCS*",
				capital_social: "Capital social*",
				membre_reseau: "Membre d'un réseau",
			},
			habilitations: {
				title: "Habilitations & autorisations",
				type_conseiller: "Type du conseiller*",
				habilitations: "Habilitations*",
				association_professionnelle: "Association professionnelle",
				numero_orias: "N°Orias",
				ligne_metier: "Ligne de metier",
			},
			gerant: {
				title: "Données du gérant",
				nom: "Nom*",
				prenom: "Prénom*",
				date_naissance: "Date de naissance*",
				email_gerant: "Email du gérant*",
			},
			coordonnes_cabinet: {
				title: "Coordonnées du cabinet",
				email_administratif: "Email administratif",
				numero_telephone: "N° de téléphone fixe",
				adresse: "Adresse (n° + rue + ville + code postal)*",
			},
			donnees_bancaires: {
				title: "Données bancaires (commission)",
				titulaire_compte: "Titulaire du compte*",
				iban: "IBAN*",
				bic: "BIC*",
			},
			produits_cabinet: {
				title: "Les produits auxquels le cabinet a accès",
				check_all_spci: "Cocher toutes les SCPI",
			},
		},
		user_details: {
			send_reminder_email_to: "Envoyer un email d'invitation à:",
			form: {
				last_name: {
					label: "Nom",
					placeholder: "Nom",
				},
				first_name: {
					label: "Prénom",
					placeholder: "Prénom",
				},
				birth_date: {
					label: "Date de naissance",
				},
				email: {
					label: "Email principal (adresse email de connexion)",
					placeholder: "Indiquer l'email",
				},
				phone_number: {
					label: "N° de téléphone mobile",
					placeholder: "N° de téléphone mobile",
				},
				etat_compte: {
					label: "Etat du compte",
					placeholder: "Etat du compte",
				},
				signature_date: {
					label: "Date de signature",
				},
				creation_date: {
					label: "Date de création",
				},
			},
		},
	},
};

export default translations;
